// extracted by mini-css-extract-plugin
export default {"typeLetterContainer":"typeLetter_typeLetterContainer__vbyFx","typeLetterContainer_incorrect":"typeLetter_typeLetterContainer_incorrect__BSA3h"};